import { Component, HostListener } from '@angular/core';
import { StorageKey, StorageService } from './services/common/storage.service';
import { UserInfoService } from './services/user-info.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'coupon-management';

  deferredPrompt: any;
  showInstallPrompt: boolean = false;

  constructor(private storageService: StorageService,
    private userInfoService: UserInfoService,
    private router: Router,
  ) { }

  @HostListener('window:beforeinstallprompt', ['$event'])
  onBeforeInstallPrompt(event: Event) {
    event.preventDefault();
    if (!localStorage.getItem('pwaInstallPrompt')) {
      this.deferredPrompt = event;
      this.showInstallPrompt = true;
    }
  }

  promptInstall() {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          this.storageService.loginSubject.next(false);
          this.userInfoService.setLoginFlag(false);
          this.userInfoService.setToken();
          this.storageService.removeValue(StorageKey.authToken);
          this.storageService.removeValue(StorageKey.currentUser);
          this.storageService.removeValue(StorageKey.menuRights);
          sessionStorage.removeItem('currentUser');
          this.router.navigate(['/']);
          //this.storageService.pwaInstallSubject.next(true);
        } else {
        }
        this.deferredPrompt = null;
        this.showInstallPrompt = false;
      });
    }
  }
}
